export enum SubscriptionStatus {
    Free = 0,
    Trial = 1,
    Paid = 2,
    Cancelled = 3,
    Expired = 4,
}
